export default "__VITE_ASSET__NV3W3GL___"